import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Item } from '../types';

@Component({
    selector: 'fcp-chip',
    templateUrl: './fcp-chip.component.html',
    styleUrls: ['./fcp-chip.component.less'],
    standalone: false
})
export class FcpChipComponent {
    @Input() size?: FcpChipSizes.Small | FcpChipSizes.Medium = FcpChipSizes.Medium;
    @Input() item: Item;
    @Input() dismissible = false;
    @Input() color: FcpChipColors = FcpChipColors.Default;

    @Output() onRemove = new EventEmitter<string>();
}

export enum FcpChipColors {
    Default = 'default',
    Success = 'success',
    Info = 'info',
    Warning = 'warning',
    Critical = 'critical',
    Light = 'light'
}

export enum FcpChipSizes {
    Small = 'small',
    Medium = 'medium'
}
